// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__BX6hD","branding":"Footer_branding__8RlZZ","title":"Footer_title__zcBo4","hypermint":"Footer_hypermint__es95R"};